<div class="ua-Table">
	<p-table
		#mydt
		[loading]="loading"
		[value]="lstUserGroup"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedGroups"
		dataKey="UserGroupID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--Group Name-->
				<th>
					<p-columnFilter type="text" field="UserGroupDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<!-- <p-columnFilter type="text" field="SchoolCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<th>
					<!-- <p-columnFilter type="text" field="PageCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="UserGroupDesc">User Group<p-sortIcon field="UserGroupDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolCount"># of Schools<p-sortIcon field="SchoolCount"></p-sortIcon></th>
				<th pSortableColumn="PageCount"># of Pages<p-sortIcon field="PageCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-usergroup>
			<tr [pSelectableRow]="usergroup">
				<td>
					<p-tableCheckbox [pSelectableRow]="usergroup" [value]="usergroup"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ usergroup[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-danger" (click)="onRemove()">Remove</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
